import classNames from 'classnames';
import * as React from 'react';
import { Collapse as ReactCollapse } from 'react-collapse';
import s from './Collapse.scss';

type CollapseActionCallback = ({
  isFullyOpened,
  isFullyClosed,
  isOpened,
  containerHeight,
  contentHeight,
}: {
  isFullyOpened: boolean;
  isFullyClosed: boolean;
  isOpened: boolean;
  containerHeight: number;
  contentHeight: number;
}) => void;

interface CollapseProps {
  onRest?: CollapseActionCallback;
  onWork?: CollapseActionCallback;
  isOpened: boolean;
  hasNestedCollapse?: boolean;
  initialStyling?: React.CSSProperties;
  className?: string;
}

export const Collapse: React.FC<CollapseProps> = ({
  isOpened,
  children,
  onRest,
  onWork,
  hasNestedCollapse,
  initialStyling = {},
  className,
}) => (
  <ReactCollapse
    isOpened={isOpened}
    initialStyle={{
      height: 0,
      overflow: 'hidden',
      ...initialStyling,
    }}
    onRest={onRest}
    onWork={onWork}
    hasNestedCollapse={hasNestedCollapse}
    theme={{ collapse: classNames(s.collapse, className) }}
  >
    {children}
  </ReactCollapse>
);
